export default __webpack_public_path__ + "static/media/Scan 309.00987d1e.jpeg";